export default __webpack_public_path__ + "52cb840be2707036e9d089e7006eecfb.png";